import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import ExternalTransferSwitch from "./ExternalTransfer/ExternalTransferSwitch";
import DataProvider from "./dataContext";
import PayeeProfile from "./Profile/PayeeProfile";

const App = () => {
  return (
    <DataProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/external/transfer" element={<ExternalTransferSwitch />} />
          <Route path="/profile" element={<PayeeProfile />} />
        </Routes>
      </BrowserRouter>
    </DataProvider>
  );
};

export default App;
